import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import TwoStepVerification from '../components/two-step-verification-view';
import {
  meData,
} from 'modules/me-module';
import environment from 'lib/environment';
import appconfig from 'config/appconfig';

const serviceUrl = environment.get().api.serviceUrl;

export class TwoStepVerificationContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      personData: Object.assign({}, this.props.personData),
      errors: {},
      isDirty: false,
    };
  }

  resetTfaOnClick = () => `${serviceUrl}enroll2fa?service=${encodeURIComponent(location.href)}`;

  getEnrolledInTfaList = () => {
    const productNames = [];
    for (const product of this.props.enrolledInTFAProducts) {
      let productName = '';
      switch (product) {
        case 'g2ars':
          productName = appconfig.logMeInProducts.g2ars;
          break;
        case 'g2asd':
          productName = appconfig.logMeInProducts.g2asd;
          break;
        case 'g2aseeit':
          productName = appconfig.logMeInProducts.g2aseeit;
          break;
        case 'g2m':
          productName = appconfig.logMeInProducts.g2m;
          break;
        case 'g2t':
          productName = appconfig.logMeInProducts.g2t;
          break;
        case 'g2w':
          productName = appconfig.logMeInProducts.g2w;
          break;
        case 'g2p':
          productName = appconfig.logMeInProducts.g2p;
          break;
        case 'openvoice':
          productName = appconfig.logMeInProducts.openvoice;
          break;
        default:
          productName = '';
      }
      if (!productNames.includes(productName)) {
        productNames.push(productName);
      }
    }
    return productNames.join(', ');
  };

  render() {
    return (
      <TwoStepVerification
        resetTfaOnClick={this.resetTfaOnClick()}
        tfaEnrolledList={this.getEnrolledInTfaList()}
      />
    );
  }
}

TwoStepVerificationContainer.propTypes = {
  personData: PropTypes.object.isRequired,
  enrolledInTFAProducts: PropTypes.array.isRequired,
};

export const mapStateToProps = (state) => ({
  personData: meData(state),
});

export default connect(mapStateToProps)(TwoStepVerificationContainer);
